import { render, staticRenderFns } from "./LingoInfo.vue?vue&type=template&id=821d872c&scoped=true"
import script from "./LingoInfo.vue?vue&type=script&lang=ts"
export * from "./LingoInfo.vue?vue&type=script&lang=ts"
import style0 from "./LingoInfo.vue?vue&type=style&index=0&id=821d872c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821d872c",
  null
  
)

export default component.exports